module.exports = __webpack_public_path__ + "img/svg/banner-card.f77fdc32eb10a3f56098ae7d248c7744.svg";